import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface SubscriptionNotesFormProps {
  formData: {
    notes: string;
  };
  updateFormData: (key: string, value: any) => void;
}

export const SubscriptionNotesForm: React.FC<SubscriptionNotesFormProps> = ({
  formData,
  updateFormData,
}) => {
  return (
    <AccordionItem value="notes">
      <AccordionTrigger>Notes</AccordionTrigger>
      <AccordionContent className="px-2">
        <div className="space-y-2 pt-2">
          <Label htmlFor="notes" className="text-sm font-medium">
            Notes (Optional)
          </Label>
          <Textarea
            id="notes"
            value={formData.notes}
            onChange={(e) => updateFormData("notes", e.target.value)}
            placeholder="Shared with family, work expense, etc."
            rows={3}
            className="glass-surface resize-none"
          />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
